import React, {useState} from "react";
import TopNavigation from "../components/TopNavigation";
import "./Work.css";

// ASENSIO SOCCER STORE
import Asensio_Cover from '../assets/Asensio Soccer Store/Asensio_Cover.jpg';
import Asensio_1 from '../assets/Asensio Soccer Store/Asensio_1.jpg';
import Asensio_2 from '../assets/Asensio Soccer Store/Asensio_2.jpg';
import Asensio_3 from '../assets/Asensio Soccer Store/Asensio_3.jpg';
import Asensio_4 from '../assets/Asensio Soccer Store/Asensio_4.jpg';
import Asensio_6 from '../assets/Asensio Soccer Store/Asensio_6.jpg';
import Asensio_7 from '../assets/Asensio Soccer Store/Asensio_7.jpg';
import Asensio_8 from '../assets/Asensio Soccer Store/Asensio_8.jpg';
import Asensio_9 from '../assets/Asensio Soccer Store/Asensio_9.jpg';

// DEEP HALLOW
import DeepHollow_Cover from '../assets/Deep Hallow/DeepHollow_Cover.jpg';
import DeepHollow_1 from '../assets/Deep Hallow/DeepHollow_1.jpg';
import DeepHollow_2 from '../assets/Deep Hallow/DeepHollow_2.jpg';
import DeepHollow_3 from '../assets/Deep Hallow/DeepHollow_3.jpg';
import DeepHollow_4 from '../assets/Deep Hallow/DeepHollow_4.png';
import DeepHollow_5 from '../assets/Deep Hallow/DeepHollow_5.jpg';
import DeepHollow_6 from '../assets/Deep Hallow/DeepHollow_6.jpg';
import DeepHollow_7 from '../assets/Deep Hallow/DeepHollow_7.jpg';
import DeepHollow_8 from '../assets/Deep Hallow/DeepHollow_8.png';

// KINGDOM OF WONDER
import Kingdom_Cover from '../assets/Kingdom of Wonder/Kingdom_Cover.jpg';
import Kingdom_1 from '../assets/Kingdom of Wonder/Kingdom_1.jpg';
import Kingdom_2 from '../assets/Kingdom of Wonder/Kingdom_2.jpg';
import Kingdom_3 from '../assets/Kingdom of Wonder/Kingdom_3.jpg';
import Kingdom_4 from '../assets/Kingdom of Wonder/Kingdom_4.jpg';
import Kingdom_5 from '../assets/Kingdom of Wonder/Kingdom_5.jpg';
import Kingdom_6 from '../assets/Kingdom of Wonder/Kingdom_6.jpg';
import Kingdom_7 from '../assets/Kingdom of Wonder/Kingdom_7.jpg';
import Kingdom_8 from '../assets/Kingdom of Wonder/Kingdom_8.jpg';
import Kingdom_9 from '../assets/Kingdom of Wonder/Kingdom_9.jpg';
import Kingdom_10 from '../assets/Kingdom of Wonder/Kingdom_10.jpg';

// LEAD CONFERENCE
import Lead_Cover from '../assets/Lead Conference/Lead_Cover.jpg';
import Lead_1 from '../assets/Lead Conference/Lead_1.jpg';
import Lead_2 from '../assets/Lead Conference/Lead_2.jpg';
import Lead_3 from '../assets/Lead Conference/Lead_3.jpg';
import Lead_4 from '../assets/Lead Conference/Lead_4.jpg';
import Lead_5 from '../assets/Lead Conference/Lead_5.jpg';
import Lead_6 from '../assets/Lead Conference/Lead_6.png';
import Lead_7 from '../assets/Lead Conference/Lead_7.jpg';
// import Edited_Web_Layout from '../assets/Lead Conference/Edited - Web layout.mov';
import Lead2021_Night2_High from '../assets/Lead Conference/Lead2021 Night 2-high.gif';

// LOVE HAS NO LIMITS
import LoveHNL_Cover from '../assets/Love Has No Limits/LoveHNL_Cover.jpg';
import LoveHNL_1 from '../assets/Love Has No Limits/LoveHNL_1.png';
import LoveHNL_2 from '../assets/Love Has No Limits/LoveHNL_2.jpg';
import LoveHNL_3 from '../assets/Love Has No Limits/LoveHNL_3.jpg';
import LoveHNL_4 from '../assets/Love Has No Limits/LoveHNL_4.png';
import LoveHNL_5 from '../assets/Love Has No Limits/LoveHNL_5.jpg';
import LoveHNL_6 from '../assets/Love Has No Limits/LoveHNL_6.jpg';
import LoveHNL_7 from '../assets/Love Has No Limits/LoveHNL_7.jpg';
import LoveHNL_8 from '../assets/Love Has No Limits/LoveHNL_8.png';
import LoveHNL_9 from '../assets/Love Has No Limits/LoveHNL_9.jpg';
import LoveHNL_10 from '../assets/Love Has No Limits/LoveHNL_10.jpg';
import LoveHNL_11 from '../assets/Love Has No Limits/LoveHNL_11.png';
import LoveHNL_12 from '../assets/Love Has No Limits/LoveHNL_12.jpg';
import LoveHNL_13 from '../assets/Love Has No Limits/LoveHNL_13.jpg';

// Malama Skin Care
import Malama_Cover from '../assets/Malama Skin Care/Malama_Cover.jpg';
import Malama_1 from '../assets/Malama Skin Care/Malama_1.jpg';
import Malama_2 from '../assets/Malama Skin Care/Malama_2.jpg';
import Malama_3 from '../assets/Malama Skin Care/Malama_3.png';
import Malama_4 from '../assets/Malama Skin Care/Malama_4.jpg';
import Malama_5 from '../assets/Malama Skin Care/Malama_5.jpg';
import Malama_6 from '../assets/Malama Skin Care/Malama_6.jpg';

// TIDY UP
import TidyUp_Cover from '../assets/Tidy Up/TidyUp_Cover.jpg';
import TidyUp_1 from '../assets/Tidy Up/TidyUp_1.jpg';
import TidyUp_2 from '../assets/Tidy Up/TidyUp_2.png';
import TidyUp_3 from '../assets/Tidy Up/TidyUp_3.png';
import TidyUp_4 from '../assets/Tidy Up/TidyUp_4.png';
import TidyUp_5 from '../assets/Tidy Up/TidyUp_5.png';
import TidyUp_6 from '../assets/Tidy Up/TidyUp_6.jpg';
import TidyUp_7 from '../assets/Tidy Up/TidyUp_7.jpg';

// UN SOLO PERU
import UnSoloPeru_Cover from '../assets/Un Solo Peru/UnSoloPeru_Cover.jpg';
import UnSoloPeru_1 from '../assets/Un Solo Peru/UnSoloPeru_1.jpg';
import UnSoloPeru_2 from '../assets/Un Solo Peru/UnSoloPeru_2.jpg';
import UnSoloPeru_3 from '../assets/Un Solo Peru/UnSoloPeru_3.jpg';
import UnSoloPeru_4 from '../assets/Un Solo Peru/UnSoloPeru_4.jpg';
import UnSoloPeru_5 from '../assets/Un Solo Peru/UnSoloPeru_5.jpg';
import UnSoloPeru_6 from '../assets/Un Solo Peru/UnSoloPeru_6.jpg';
import UnSoloPeru_7 from '../assets/Un Solo Peru/UnSoloPeru_7.jpg';
import UnSoloPeru_8 from '../assets/Un Solo Peru/UnSoloPeru_8.png';
import UnSoloPeru_9 from '../assets/Un Solo Peru/UnSoloPeru_9.png';
import UnSoloPeru_10 from '../assets/Un Solo Peru/UnSoloPeru_10.jpg';
import UnSoloPeru_11 from '../assets/Un Solo Peru/UnSoloPeru_11.png';
import UnSoloPeru_12 from '../assets/Un Solo Peru/UnSoloPeru_12.jpg';
import UnSoloPeru_13 from '../assets/Un Solo Peru/UnSoloPeru_13.jpg';
import UnSoloPeru_14 from '../assets/Un Solo Peru/UnSoloPeru_14.png';
import UnSoloPeru_15 from '../assets/Un Solo Peru/UnSoloPeru_15.png';
import UnSoloPeru_16 from '../assets/Un Solo Peru/UnSoloPeru_16.jpg';

// VIGOR MAGAZINE
import Vigor_Cover from '../assets/VIGOR Magazine/Vigor_Cover.jpg';
import Vigor_1 from '../assets/VIGOR Magazine/Vigor_1.jpg';
import Vigor_2 from '../assets/VIGOR Magazine/Vigor_2.png';
import Vigor_3 from '../assets/VIGOR Magazine/Vigor_3.jpg';
import Vigor_4 from '../assets/VIGOR Magazine/Vigor_4.jpg';
import Vigor_5 from '../assets/VIGOR Magazine/Vigor_5.jpg';
import Vigor_6 from '../assets/VIGOR Magazine/Vigor_6.jpg';
import Vigor_7 from '../assets/VIGOR Magazine/Vigor_7.jpg';

const Work = () => {

    const [isModalOpen, setModalOpen] = useState(false);
    const [activeProject, setActiveProject] = useState(null);
    const [activeImage, setActiveImage] = useState(null);

    const projects = [
        {
            id: 1,
            title: "Vigor Magazine",
            thumbnail: Vigor_Cover,
            gallery: [
                Vigor_1,
                Vigor_2,
                Vigor_3,
                Vigor_4,
                Vigor_5,
                Vigor_6,
                Vigor_7
            ],
            description: "VIGOR is a health and travel magazine that inspires readers to take care of their bodies physically and mentally through proper nutrition, regular activity, and travel. Each month, the magazine offers a unique experience by exploring different cultures and highlighting how people around the world maintain their health and happiness.",
            role: "Overall project lead, including creation, writing, photography, and design"
        },
        {
            id: 2,
            title: "Lead 2021",
            thumbnail: Lead_Cover,
            gallery: [
                Lead_1,
                Lead_2,
                Lead_3,
                Lead_4,
                Lead_5,
                Lead_6,
                Lead_7,
                // Edited_Web_Layout,
                Lead2021_Night2_High
            ],
            description: "Lead 2021 was a three-night leadership conference streamed live in Los Angeles, featuring business and evangelical leaders sharing insights on empowerment, positioning, and leadership. The event required a range of digital assets, including Instagram and website graphics, screen backgrounds, and lower thirds for the live broadcasts.",
            role: "Lead designer - all digital & broadcast assets"
        },
        {
            id: 3,
            title: "Social Good Campaign",
            thumbnail: TidyUp_Cover,
            gallery: [
                TidyUp_1,
                TidyUp_2,
                TidyUp_3,
                TidyUp_4,
                TidyUp_5,
                TidyUp_6,
                TidyUp_7
            ],
            description: "Tidy Up is a social good campaign aimed at reducing disposable waste by highlighting its impact on marine life. Through editorial, social media, and environmental graphics in stores, the campaign raises awareness and encourages action. Participants can join the project by collecting two bags of recyclable trash, and in return, receive a free water bottle or beach bag of their choice.",
            role: "Lead creator & Designer"
        },
        {
            id: 4,
            title: "Love Has No Limits & Foster Care",
            thumbnail: LoveHNL_Cover,
            gallery: [
                LoveHNL_1,
                LoveHNL_2,
                LoveHNL_3,
                LoveHNL_4,
                LoveHNL_5,
                LoveHNL_6,
                LoveHNL_7,
                LoveHNL_8,
                LoveHNL_9,
                LoveHNL_10,
                LoveHNL_11,
                LoveHNL_12,
                LoveHNL_13
            ],
            description: "Love Has No Limits (LHNL) was a campaign supporting low-income families and foster children in Los Angeles. The initiative included foster care events, gift donations, adoption interviews, and distribution of food, clothing, and supplies. The campaign required banners, pop-up signs, t-shirts, and social media graphics for awareness.",
            role: "Lead designer - all print and digital materials"
        },
        {
            id: 5,
            title: "Asensio Soccer Store",
            thumbnail: Asensio_Cover,
            gallery: [
                Asensio_1,
                Asensio_2,
                Asensio_3,
                Asensio_4,
                Asensio_6,
                Asensio_7,
                Asensio_8,
                Asensio_9
            ],
            description: "Inspired by Spanish soccer player Marco Asensio, this concept project envisions a brand dedicated to providing affordable gear for those unable to afford big-name brands. The design captures ASENSIO’s mission to foster a sense of acceptance and community within the soccer world.",
            role: "Lead creator & Marketing Designer"
        },
        {
            id: 6,
            title: "Un Solo Peru",
            thumbnail: UnSoloPeru_Cover,
            gallery: [
                UnSoloPeru_1,
                UnSoloPeru_2,
                UnSoloPeru_3,
                UnSoloPeru_4,
                UnSoloPeru_5,
                UnSoloPeru_6,
                UnSoloPeru_7,
                UnSoloPeru_8,
                UnSoloPeru_9,
                UnSoloPeru_10,
                UnSoloPeru_11,
                UnSoloPeru_12,
                UnSoloPeru_13,
                UnSoloPeru_14,
                UnSoloPeru_15,
                UnSoloPeru_16
            ],
            description: "Un Solo Perú (“One Peru” in Spanish) was a humanitarian aid movement mobilizing 3,000 international and 7,000 Peruvian volunteers over 10 days. The effort included eight stadium outreach events across the country. Supporting the mission, print materials such as flyers, brochures, banners, backdrops, stickers, giveaway items, and social media graphics were created to engage and inform participants.",
            role: "Lead designer - all print and digital materials"
        },
        {
            id: 7,
            title: "Museum Exhibit",
            thumbnail: Kingdom_Cover,
            gallery: [
                Kingdom_1,
                Kingdom_2,
                Kingdom_3,
                Kingdom_4,
                Kingdom_5,
                Kingdom_6,
                Kingdom_7,
                Kingdom_8,
                Kingdom_9,
                Kingdom_10
            ],
            description: "This interactive design project offers an engaging tour of Cambodia, showcasing its rich culture and the iconic Angkor Wat. Designed to be educational and immersive, the exhibit, along with an informational booklet, encourages exploration and curiosity about unfamiliar cultures and destinations.",
            role: "Lead Innovator & Designer"
        },
        {
            id: 8,
            title: "Deep Hollow Trail Race",
            thumbnail: DeepHollow_Cover,
            gallery: [
                DeepHollow_1,
                DeepHollow_2,
                DeepHollow_3,
                DeepHollow_4,
                DeepHollow_5,
                DeepHollow_6,
                DeepHollow_7,
                DeepHollow_8
            ],
            description: "The Deep Hollow 5K and Half Marathon is an annual trail race held at Liberty University’s Camp Hydaway. The hand-drawn t-shirt design incorporates the Outdoor Recreation department’s logo in a hexagon shape, symbolizing the rugged trails through the mountains of Virginia. The black long-sleeve shirt was created for the half marathon runners, while the short-sleeve gray shirt was designed for the 5K runners.",
            role: "Lead Designer"
        },
        {
            id: 9,
            title: "Malama Skin Care Packaging",
            thumbnail: Malama_Cover,
            gallery: [
                Malama_1,
                Malama_2,
                Malama_3,
                Malama_4,
                Malama_5,
                Malama_6
            ],
            description: "Malama is an all-natural, organic skincare company, named after the Hawaiian word meaning to care for, preserve, and protect. The brand offers products designed to nourish and moisturize the skin, promoting a healthy equilibrium. Their range includes bath salts, bar soap, body lotion, and face cream, each crafted with ingredients that provide essential care and protection.",
            role: "Lead creator & Designer"
        }
    ];

    const openModal = (project) => {
        setActiveProject(project);
        setActiveImage(project.gallery[0]);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setActiveProject(null);
    };

    // Function to break each word of the title into a new line
    const formatTitle = (title) => {
        return title.split(" ").map((word, index) => (
            <span key={index} className="title-word">
        {word}
                <br />
      </span>
        ));
    };

    return (

        <div className="app">
            <TopNavigation/>

            <div className="work-page">
                <h1>explore the work</h1>
                <div className="project-grid artistic-layout">
                    {projects.map((project, index) => (
                        <div
                            key={project.id}
                            className={`project-card ${project.title.replace(/\s+/g, "_").toUpperCase()}`}
                            onClick={() => openModal(project)}
                        >
                            <img src={project.thumbnail} alt={project.title}/>
                        </div>
                    ))}
                </div>

                {isModalOpen && activeProject && (
                    <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal-content-work" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-close-icon" onClick={closeModal}>×</div>

                            <div className="modal-header">
                                <div className="modal-title">{formatTitle(activeProject.title)}</div>
                                <div className="modal-description">
                                    <p>{activeProject.description}</p>
                                    <p><strong>Role:</strong> {activeProject.role}</p>
                                </div>
                            </div>

                            <div className="presentation-image">
                                <img src={activeImage} alt="Presentation" />
                            </div>

                            <div className="thumbnail-gallery">
                                {activeProject.gallery.map((image, index) => (
                                    <img
                                        key={index}
                                        src={image}
                                        alt={`Gallery Thumbnail ${index + 1}`}
                                        className={`thumbnail ${image === activeImage ? "active" : ""}`}
                                        onClick={() => setActiveImage(image)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default Work;

